/**
 * title: Bookings
 **/
import { bookings } from "./_organisms/bookings/bookings";

// Load all JS after Content Load
document.addEventListener("DOMContentLoaded", function () {
	bookings();
});
